import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import useMenu from '~/composables/useMenu';
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuTopbarGraphql',
  props: {
    menuItems: {
      type: Object,
      required: false,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers;
    var _useMenu = useMenu(),
      getMenuItemLink = _useMenu.getMenuItemLink;
    var MenuSubcategoryListGraphql = function MenuSubcategoryListGraphql() {
      return import('~/components/Molecules/MenuSubcategoryListGraphql.vue');
    };
    var route = useRoute();
    var activeCategoryId = ref(null);
    var consolidatedMenuItems = computed(function () {
      var _props$menuItems, _props$menuItems$item, _props$menuItems2, _props$menuItems2$ite, _props$menuItems3, _props$menuItems3$lea, _props$menuItems4, _props$menuItems4$lea;
      var items = [];
      if ((_props$menuItems = props.menuItems) !== null && _props$menuItems !== void 0 && (_props$menuItems$item = _props$menuItems.itemsCollection) !== null && _props$menuItems$item !== void 0 && _props$menuItems$item.items.length) items = items.concat((_props$menuItems2 = props.menuItems) === null || _props$menuItems2 === void 0 ? void 0 : (_props$menuItems2$ite = _props$menuItems2.itemsCollection) === null || _props$menuItems2$ite === void 0 ? void 0 : _props$menuItems2$ite.items);
      if ((_props$menuItems3 = props.menuItems) !== null && _props$menuItems3 !== void 0 && (_props$menuItems3$lea = _props$menuItems3.learnLinksCollection) !== null && _props$menuItems3$lea !== void 0 && _props$menuItems3$lea.items.length) items = items.concat((_props$menuItems4 = props.menuItems) === null || _props$menuItems4 === void 0 ? void 0 : (_props$menuItems4$lea = _props$menuItems4.learnLinksCollection) === null || _props$menuItems4$lea === void 0 ? void 0 : _props$menuItems4$lea.items);
      return items;
    });
    watch(route, function () {
      activeCategoryId.value = null;
    });

    /**
     * Shows the dropdown for the given menu.
     *
     * @param      {Object}  item    The menu item to display
     */
    function showDropdown(item) {
      var _item$subItemsCollect;
      if (item !== null && item !== void 0 && (_item$subItemsCollect = item.subItemsCollection) !== null && _item$subItemsCollect !== void 0 && _item$subItemsCollect.items.length) {
        activeCategoryId.value = item.sys.id;
      } else {
        hideDropdown();
      }
    }

    /**
     * Hides the dropdown.
     */
    function hideDropdown() {
      activeCategoryId.value = null;
    }

    /**
     * Gets the sub items.
     *
     * @param      {Object}  item    The parent item
     * @return     {Array}  The sub items.
     */
    function getSubItems(item) {
      var _item$subItemsCollect2, _item$subItemsCollect3;
      return (_item$subItemsCollect2 = item === null || item === void 0 ? void 0 : (_item$subItemsCollect3 = item.subItemsCollection) === null || _item$subItemsCollect3 === void 0 ? void 0 : _item$subItemsCollect3.items) !== null && _item$subItemsCollect2 !== void 0 ? _item$subItemsCollect2 : [];
    }

    /**
     * Gets the item link.
     * If the item is not of type `highlight` it shouldn't return a link.
     * SEO Purpose
     *
     * @param      {Object}  item    The item
     */
    function getItemLink(item) {
      if (item.type !== 'Highlight' && !(item !== null && item !== void 0 && item.externalLinkUrl)) return '';
      return getMenuItemLink(item);
    }

    /**
     * Gets the item nuxt-link tag.
     *
     * @param      {Object}  item    The item
     * @return     {String}  The item tag.
     */
    function getItemTag(item) {
      return getItemLink(item) ? 'a' : 'div';
    }
    return {
      __sfc: true,
      $trackers: $trackers,
      getMenuItemLink: getMenuItemLink,
      MenuSubcategoryListGraphql: MenuSubcategoryListGraphql,
      props: props,
      route: route,
      activeCategoryId: activeCategoryId,
      consolidatedMenuItems: consolidatedMenuItems,
      showDropdown: showDropdown,
      hideDropdown: hideDropdown,
      getSubItems: getSubItems,
      getItemLink: getItemLink,
      getItemTag: getItemTag,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});